module.exports = __webpack_public_path__ + "img/well.a63c4cb9.png";